<template>
    <div v-if="showProgressBar" class="progress-bar">
        <div class="bar" :style="{ width: `${finishedPercentage}%` }"></div>
    </div>
</template>

<script setup lang="ts">
import { useStepsStore } from '@/widgets/Wizard/stores/steps';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const stepsStore = useStepsStore();
const { totalStepsAmount, completedStepsAmount, showProgressBar } = storeToRefs(stepsStore);

const finishedPercentage = computed(() => {
    if (completedStepsAmount.value === 0 || totalStepsAmount.value === 0) {
        return 0;
    }

    return (completedStepsAmount.value / totalStepsAmount.value) * 100;
});
</script>
